import * as React from 'react';

function SvgVideoOffIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit={2}
            {...props}>
            <path
                d="M20.227 20.563L2.318 3.018a.691.691 0 010-.973.69.69 0 01.973 0L21.199 19.59a.687.687 0 11-.972.973zM16.125 7.878v2.751a.688.688 0 01-1.375 0V7.878a.682.682 0 00-.202-.485.682.682 0 00-.485-.202h-3.438a.688.688 0 010-1.375h3.438a2.063 2.063 0 012.062 2.062zm-2.75 8.938H3.063a.688.688 0 01-.688-.688v-8.25a.685.685 0 01.688-.687.688.688 0 000-1.375A2.062 2.062 0 001 7.878v8.25a2.062 2.062 0 002.063 2.063h10.312a.688.688 0 100-1.375zm7.636.117l-2.372-1.184a2.061 2.061 0 01-1.139-1.845v-3.8c0-.383.106-.759.307-1.084v-.001c.202-.326.49-.589.832-.76l2.372-1.185A1.374 1.374 0 0123 8.304v7.399a1.377 1.377 0 01-1.313 1.374 1.364 1.364 0 01-.676-.144zm-2.033-2.667a.692.692 0 00.277.254l2.37 1.183V8.304l-2.37 1.184a.685.685 0 00-.38.615v3.802c0 .127.035.253.103.361z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgVideoOffIcon;
